import React from "react";
import { Button } from "reactstrap";
import { getListRangeLabel } from "./aiVisibilityListConstants";

export default function JobsListPagination({
	page,
	pageSize,
	total,
	hasMore,
	onPageChange,
	loading = false,
}) {
	const totalPages = Math.max(1, Math.ceil((total || 0) / pageSize));
	const showFooter = total > pageSize || page > 0;

	if (!showFooter || loading) {
		return null;
	}

	const nextDisabled =
		hasMore === false || page + 1 >= totalPages;

	return (
		<div className="ai-visibility-jobs-pagination d-flex justify-content-between align-items-center mt-4">
			<Button
				color="light"
				size="sm"
				className="border"
				disabled={page <= 0}
				onClick={() => onPageChange(page - 1)}
			>
				<i className="fas fa-chevron-left me-1" />
				Previous
			</Button>
			<span className="text-muted small">{getListRangeLabel(page, pageSize, total)}</span>
			<Button
				color="light"
				size="sm"
				className="border"
				disabled={nextDisabled}
				onClick={() => onPageChange(page + 1)}
			>
				Next
				<i className="fas fa-chevron-right ms-1" />
			</Button>
		</div>
	);
}
